module.exports = __webpack_public_path__ + "static/media/How users with owner permissions can change their own password.19d3c0f2.png";